var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagramMobileSponsored = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "m5.761 0 .79 1.575q.23.04.454.104l-.181-.152 1.93-.347-.005 1.455q.278.245.513.533l-.034-.09 1.759.43-.897 1.22q.07.233.115.476l.009-.049 1.309 1.25-1.35.593a5 5 0 0 1-.144.512l.316 1.759-1.436-.005a5 5 0 0 1-.472.4L7.776 11.5l-1.649-.959h.136v-5.27L8.02 7.028l.753-.753-2.51-2.761H5.26l-2.51 2.76.753.754L5.26 5.27v5.27h.136l-1.648.959-.662-1.836a5 5 0 0 1-.472-.4l-1.453.005.322-1.793a5 5 0 0 1-.133-.478L0 6.405l1.309-1.25.008.052q.045-.244.115-.479l-.896-1.22 1.758-.43-.032.088q.207-.255.449-.475l-.004-1.51 1.93.346-.22.182q.272-.084.556-.135z"
})));
export default SvgInstagramMobileSponsored;